import update from 'immutability-helper';
import pDebounce from 'debounce-promise';
import React from 'react';
import request from '../../commons/services/request';
import SelectErrorMessage from '../../commons/components/SelectErrorMessage';
import { triggerSettingsUpdatedEvent } from '../../commons/services/Wix';
import {
  AUTH_ERROR,
  UNEXPECTED_ERROR
} from '../../commons/services/errorCodes';

// here we are gonna handle the state of the settings area.
// if stuff gets too complex, we will switch to redux or mobx.
// component specfic ui-state can also be handled in the sub-component
// but the main state should ne handled in here.
function createSettingsStateContainer(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.setData = this.setData.bind(this);
      this.updateData = this.updateData.bind(this);
      this.fetchData = this.fetchData.bind(this);

      // debounce the save operation. because it gets
      // called for example onChange of text inputs (which
      // could be quite often).
      this.saveData = pDebounce(this.saveData.bind(this), 250);

      this.state = {
        // data contains the the settings data.
        // if a setting gets changed, we are just gonna
        // save the entire data away.
        data: null,
        // keep the last successfully saved data arround.
        // so we can revert to that data if something fails.
        lastSavedData: null,

        errorCode: null
      };
    }

    setData(data, save = true, triggerSettingsUpdate = true) {
      // for now we will optimisticly update data
      // to keep the UI more responsive.
      this.setState(() => ({
        data
      }));

      if (triggerSettingsUpdate) {
        triggerSettingsUpdatedEvent(data);
      }

      if (save) {
        // store the settings in the backend
        return this.saveData(data);
      }
    }

    saveData(dataArg) {
      // filter data which should not be saved
      const data = update(dataArg, { $unset: ['hoverBadge'] });

      return request
        .put('/api/settings/draft', data)
        .catch(err => {
          // revert data if save failed
          this.setState(({ lastSavedData }) => {
            triggerSettingsUpdatedEvent(lastSavedData);
            return {
              data: lastSavedData,
              errorCode: err.response.status === 403
                ? AUTH_ERROR
                : UNEXPECTED_ERROR
            };
          });
          return Promise.reject(err);
        })
        .then(res => {
          this.setState(() => ({
            lastSavedData: data
          }));
          return res;
        });
    }

    // update data using immutability-helper
    updateData(data, spec, save, triggerSettingsUpdate) {
      return this.setData(update(data, spec), save, triggerSettingsUpdate);
    }

    fetchData() {
      return request.get(`/api/settings/draft`).then(
        ({ data }) => {
          this.setState(() => ({
            data,
            lastSavedData: data
          }));
        },
        err => {
          this.setState(() => {
            return {
              errorCode: err.response.status === 403
                ? AUTH_ERROR
                : UNEXPECTED_ERROR
            };
          });
        }
      );
    }

    componentDidMount() {
      this.fetchData();
    }

    render() {
      const { errorCode } = this.state;

      if (errorCode) {
        return <SelectErrorMessage code={errorCode} />;
      }

      return (
        <WrappedComponent
          {...this.state}
          {...this.props}
          updateData={this.updateData}
          fetchData={this.fetchData}
        />
      );
    }
  };
}

export default createSettingsStateContainer;



// WEBPACK FOOTER //
// ./src/commons/components/createSettingsStateContainer.jsx